export default __webpack_public_path__ + "static/media/changelog.30df11c6.md";